import InfoIcon from '../../../../assets/images/final-assessment-info.svg'
import { getTranslatedText } from '../../../../utils/getTranslatedText';
import { useGetTranslatedText } from '../../lms/queries';

import styles from "./styles.module.scss";

const ExitAssessmentModal = ({ onExit, onContinue }) => {
    const languageId = localStorage.getItem("l_id") || 1;
          
    const { data: translatedTextResponse } = useGetTranslatedText(languageId);
          
    const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Icon */}
        <div className={styles.iconWrapper}>
          <div className={styles.icon}>
            <img src={InfoIcon} alt='' />
          </div>
        </div>

        {/* Title */}
        <h2 className={styles.title}>
          {
            getTranslatedText(
              translatedText,
              "key_exit_assessment",
              "Exit Assessment?",
          )} 
          </h2>

        {/* Description */}
        <p className={styles.description}>
           {
              getTranslatedText(
                          translatedText,
                          "key_you_exit_now",
                        `If you exit now, your current progress will be lost and you will need
          to start the assessment again`,
              )} 
        </p>

        {/* Buttons */}
        <button className={styles.exitBtn} onClick={onExit}>
          {
          getTranslatedText(
                          translatedText,
                          "key_btn_exit",
                        `Exit`,
          )}
        </button>

        <button className={styles.continueBtn} onClick={onContinue}>
            {
          getTranslatedText(
                          translatedText,
                          "key_continue_assessment",
                        `Continue Assessment`,
          )}
        </button>
      </div>
    </div>
  );
};

export default ExitAssessmentModal;